// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3Bkxf","buttons":"SendReceipts_buttons__14xJ5","email":"SendReceipts_email__1K5v7","bookApptTitle":"SendReceipts_bookApptTitle__Yks2R"};